import { render, staticRenderFns } from "./login-card.vue?vue&type=template&id=f90cc344"
import script from "./login-card.vue?vue&type=script&lang=js"
export * from "./login-card.vue?vue&type=script&lang=js"
import style0 from "./login-card.vue?vue&type=style&index=0&id=f90cc344&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports